module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_01@2x-43dab55e7139673311fd3f84a92e19c8.webp";